import { defineStore } from 'pinia';
import { isBoolean } from 'lodash';
import { useBrowserStorage } from '@/utils/useBrowserStorage';

export const useTranslationKeyStore = defineStore('translationKey', () => {
  // make these functions globally accessible, such that e2e tests can call them via eval()
  window.PTW_enableTranslationKeys = enableTranslationKeys;
  window.PTW_disableTranslationKeys = disableTranslationKeys;
  window.PTW_toggleTranslationKeys = toggleShowTranslationKeys;

  // register a global hotkey to toggle translation keys: Ctrl + Alt + k
  window.addEventListener('keydown', function (e: KeyboardEvent) {
    if (e.ctrlKey && e.altKey && e.code === 'KeyK') {
      toggleShowTranslationKeys();
    }
  });

  const showTranslationKeys = useBrowserStorage({
    key: 'useKeys',
    defaultValue: false,
    validator: isBoolean,
    type: 'sessionStorage',
  });

  async function toggleShowTranslationKeys() {
    showTranslationKeys.value = !showTranslationKeys.value;
  }

  function enableTranslationKeys() {
    showTranslationKeys.value = true;
  }

  function disableTranslationKeys() {
    showTranslationKeys.value = false;
  }

  return {
    showTranslationKeys,
    enableTranslationKeys,
    disableTranslationKeys,
    toggleShowTranslationKeys,
  };
});
